export const getUserId = (userIdBase: number) => {
    return `user${userIdBase}`;
};
